import NativeApi from '@threegene/common-js/native-api';

const UseNativeApi = {
  install: (vue, option) => {
    const defOption = {
      debug: false,
      isProd: process.env['HOST'] === 'prod'
    };
    option = {...option, ...defOption};
    vue.prototype.$nativeApi = NativeApi(option);
  }
};
export {UseNativeApi};



// WEBPACK FOOTER //
// ./src/js/util/initNativeApi.js